import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'

@Component({
  selector: 'ddc-rotating-border-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ddc-rotating-border-card.component.html',
  styleUrl: './ddc-rotating-border-card.component.scss',
})
export class DdcRotatingBorderCardComponent {}
